﻿export function initSessionCountdown(options = {}) {
    const {
        totalSeconds = 0,
        timerSelector = "#paymentSessionCountdown",
        cardSelector = "#paymentSessionCard",
        warningThreshold = 60
    } = options;

    const timer = document.querySelector(timerSelector);
    const card = document.querySelector(cardSelector);

    if (!timer || !card || !Number.isFinite(totalSeconds)) return;

    let remaining = totalSeconds;

    function render() {
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;

        timer.textContent =
            `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

        if (remaining <= warningThreshold) {
            card.classList.add("is-warning");
        }
    }

    render();

    const interval = window.setInterval(() => {
        remaining--;

        if (remaining < 0) {
            clearInterval(interval);
            timer.textContent = "00:00";
            card.classList.remove("is-warning");
            card.classList.add("is-expired");
            return;
        }

        render();
    }, 1000);
}